export const SET_PRICING = 'SET_PRICING';
export const SET_ACTION = 'SET_ACTION';
export const SET_STEP = 'SET_STEP';
export const SET_AMOUNT = 'SET_AMOUNT';
export const SET_BID_AMOUNT = 'SET_BID_AMOUNT';
export const SET_ERROR = 'SET_ERROR';
export const SET_DISCOUNT_CODE = 'SET_DISCOUNT_CODE';
export const SET_EXPIRATION = 'SET_EXPIRATION';
export const SET_DELIVERY_METHOD = 'SET_DELIVERY_METHOD';
export const SET_MARKET_STATE = 'SET_MARKET_STATE';

export enum CheckoutFlowPage {
  SizeSelectorPage = 'Size Selector Page',
  SizeChartPage = 'Size Chart Page',
  BuyNowForm = 'Buy Now Form',
  PlaceBidForm = 'Place Bid Form',
  ReviewPurchaseScreen = 'Review Purchase Screen',
  ReviewBidScreen = 'Review Bid Screen',
  ShippingInfoScreen = 'Shipping Info Screen',
  BillingInfoScreen = 'Billing Info Screen',
  HowItWorks = 'How It Works',
  InternationalNotAllowed = 'International Not Allowed',
  LockedAction = 'Locked Action',
  BuyingForm = 'Buying Form',
  BuyingConfirm = 'Buying Confirm',
  MFARequired = 'MFA Required',
}

export enum BuyFlowStep {
  SizeSelect = 'Checkout Size Select',
  BidEntry = 'Checkout Bid Entry',
  Billing = 'Checkout Billing',
  Shipping = 'Checkout Shipping',
  RegulatoryId = 'Checkout Regulatory Id',
  Review = 'Checkout Review',
  Success = 'Checkout Success',
}

export const VatRegistrationLinkMap = {
  en: 'http://stockx.com/news/vat-registration',
  de: 'http://stockx.com/news/de-de/vat-registration-de',
  it: 'http://stockx.com/news/it-it/vat-registration-it',
  fr: 'http://stockx.com/news/fr-fr/vat-registration-fr',
};
